var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from '@utils/axios';
import { customerPortalDeficienciesPath, customerPortalDeficiencyPath } from '@routes';
import kendoDatatableParams from '../../../../../helpers/kendoDatatableParams';
export default class DeficienciesService {
    static getDeficiencies(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const queryParams = kendoDatatableParams({
                    page: params.page,
                    sort: params.sort,
                    filters: params.filters
                });
                const response = yield api.get(customerPortalDeficienciesPath({ format: 'json' }), {
                    params: queryParams
                });
                return response.data;
            }
            catch (error) {
                console.error('Error fetching deficiencies:', error);
                throw error;
            }
        });
    }
    static getDeficiency(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield api.get(customerPortalDeficiencyPath(id), {
                    headers: {
                        Accept: 'application/json'
                    }
                });
                return response.data;
            }
            catch (error) {
                console.error('Error fetching deficiency:', error);
                throw error;
            }
        });
    }
}
